module.exports = __webpack_public_path__ + "img/system34-mini.01e02ba3.png";